/**
 * F-10 AUDIT-LINK — map an audit entry's entityType + entityId to an in-app route.
 *
 * Routes VERIFIED against App.tsx + AdminShell.tsx (2026-06-28):
 *   client     → /clients/:clientId        (App.tsx)
 *   screening  → /screening/:screeningId   (App.tsx)
 *   assignment → /pre-call/:assignmentId   (App.tsx)
 *   batch      → /admin/batches/:id        (AdminShell.tsx, nested under /admin/*)
 *
 * Returns `null` for entityTypes WITHOUT a dedicated navigable route (booking,
 * household_member, user, system_config, call_attempt, audit_log, agent, etc.) —
 * callers MUST render plain text in that case (never navigate to a 404).
 *
 * Case-insensitive on entityType.
 */
export function entityTypeToPath(
  entityType: string | null | undefined,
  entityId: string | number | null | undefined,
): string | null {
  if (
    !entityType ||
    entityId === null ||
    entityId === undefined ||
    entityId === ''
  ) {
    return null;
  }
  const t = String(entityType).toLowerCase().trim();
  const id = encodeURIComponent(String(entityId));
  switch (t) {
    case 'client':
      return `/clients/${id}`;
    case 'screening':
      return `/screening/${id}`;
    case 'assignment':
      return `/pre-call/${id}`;
    case 'batch':
      return `/admin/batches/${id}`;
    default:
      return null;
  }
}
